<template lang="pug">
  v-container
    v-card
      v-card-title
        v-spacer
        v-spacer
        v-spacer
        v-spacer
        v-text-field.mr-3(v-model='saved.search', append-icon='search', :label='$t("words.search")', hide-details)
        v-btn(@click="getPatients" flat icon)
          v-icon refresh
        v-btn(color="primary" @click="create") {{ $t('words.new') }}
      v-data-table.data-table.elevation-1(:loading='loading' :pagination.sync="saved.pagination" :headers='headers', :items='saved.items', :total-items="10000", hide-actions)
        template(slot="items" slot-scope='props')
          tr(@click="$router.push(`/ultra-fetal/patient/${props.item.iuid}`)")
            td {{ props.item.name | uppercase }}
            td.text-xs-center {{ props.item.identity | cpf }}
            td.text-xs-center {{ props.item.birthdate | formatDate }}
            td.text-xs-center
              v-menu(offset-y, left)
                template(v-slot:activator="{ on }")
                  v-btn.mx-0(v-on="on", @click.stop="" icon='')
                    v-icon(small='')
                      | more_vert
                v-list
                  v-list-tile(@click="edit(props.item.iuid)")
                    v-list-tile-title {{ $t('words.edit') | capitalize }}
                  v-list-tile(:to="`/ultra-fetal/patient/${props.item.iuid}`")
                    v-list-tile-content
                      v-list-tile-title UltraFetal
                    v-list-tile-action
                      v-btn(icon, ripple, :to="`/ultra-fetal/patient/${props.item.iuid}`", target="_blank", @click.stop="")
                        v-icon open_in_new
                  v-list-tile(@click="newGeneralReport(props.item.iuid)")
                    v-list-tile-title Criar atendimento
    v-btn.mt-3(v-if='hideMoreBtn' block color="primary" @click="saved.pagination.rowsPerPage += itemsPerPage") Mais
    UfPatient(v-model="dialogPatient", :iuid='patientIuid')
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { core, db } from '../store/firebase'
import { mapState, mapActions } from 'vuex'

import apiGestation from '@/api/gestation'
import firestoreUtil from '@/utils/firestore'
import UfPatient from '@/components/ultra-fetal/home/Patient'

export default {
  components: {
    UfPatient
  },

  props: {
    itemsPerPage: {
      type: Number,
      default: 20
    }
  },

  computed: {
    ...mapState({
      user: state => state.user,
      company: state => state.company,
      dataState: (state) => state.patientsState,
      patient: (state) => state.ultraFetal.patient,
      companyUltraFetal: (state) => state.ultraFetal.company
    }),
    headers () {
      const { f } = this
      return [
        { text: f(this.$t('words.name'), 'capitalize'), value: 'name', sortable: false },
        { text: f(this.$t('words.identity'), 'uppercase'), value: 'identity', sortable: false, align: 'center' },
        { text: f(this.$t('messages.birthdate'), 'capitalize'), value: 'birthdate', sortable: false, align: 'center' },
        { text: f(this.$tc('words.action', 2), 'capitalize'), value: 'actions', sortable: false, align: 'center' }
      ]
    },
    gestationsItems () {
      let items = []
      this.gestations.forEach(gestation => {
        gestation.interactions = this.gestationInteractions[gestation.iuid] || []
        items.push(gestation)
      })

      return items
    },
    currentGestation () {
      if (this.gestationsItems.length === 0) return null
      return this.gestationsItems[0]
    }
  },

  data () {
    return {
      gestations: [],
      loading: false,
      pagination: {
        rowsPerPage: this.itemsPerPage
      },
      hideMoreBtn: false,
      saved: {
        items: [],
        pagination: {
          rowsPerPage: 20
        },
        search: ''
      },
      dialogPatient: false,
      patientIuid: null
    }
  },

  created () {
    if (this.dataState) {
      this.saved = this.dataState
    }
  },

  beforeDestroy () {
    this.setPatientsState(this.saved)
  },

  watch: {
    'saved.pagination': {
      handler: function (val) {
        this.getPatients()
      },
      deep: true
    },
    'saved.search' () {
      this.saved.pagination.rowsPerPage = this.itemsPerPage
      this.getPatients()
    },
    dialogPatient (val) {
      if (!val) this.getPatients()
    }
  },

  mounted () {
    this.getPatients()
  },

  methods: {
    ...mapActions(['setPatientsState']),
    create () {
      this.patientIuid = null
      this.dialogPatient = true
    },
    edit (iuid) {
      this.patientIuid = iuid
      this.dialogPatient = true
    },
    newGestation (iuid) {
      return db.collection('gestations').add({
        date: new Date(),
        company: db.doc('companies/' + this.companyUltraFetal),
        patient: db.doc('patients/' + iuid)
      }).then(data => {
        return data
      })
    },
    async newGeneralReport (iuid) {
      try {
        this.$swal.fire({
          type: 'info',
          title: 'Criando atendimento por favor aguarde',
          showCancelButton: false,
          showConfirmButton: false
        })
        await this.$store.dispatch('ultraFetal/getCompany', this.company)
        await this.$store.dispatch('ultraFetal/getPatient', iuid)
        const formsBase = this.gestationFormsBase()
        let studyAn = formsBase['gestationalAge.info.accessionNumber']
        let studies = {[studyAn]: {'accessionNumber': formsBase['gestationalAge.info.accessionNumber'], 'title': 'EXAME', 'date': new Date()}}

        // Verificar se o usuário atual é médico
        const isDoctor = this.user && this.user.role === 'doctor'

        // Se não for médico, passar null como médico responsável
        const doctorToAssign = isDoctor ? this.user : null

        await apiGestation.createGestationInteraction(this.patient, doctorToAssign, this.companyUltraFetal, formsBase, studies)
        apiGestation.updatePatientLastInteraction(this.patient.iuid)
        this.$swal.fire({
          type: 'success',
          title: 'Atendimento criado com sucesso (AN:' + studyAn + ')',
          focusConfirm: false,
          confirmButtonText: 'OK'
        })
      } catch (e) {
        let errorText = ''
        if (this.patient) {
          if (!this.patient.birthdate) {
            errorText = errorText + 'DATA DE NASCIMENTO, '
          }
          if (!this.patient.sex) {
            errorText = errorText + 'SEXO, '
          }
          if (!this.patient.name) {
            errorText = errorText + 'NOME. '
          }
          if (errorText !== '') {
            errorText = 'por favor preencher o(s) campo(s) : ' + errorText
          } else {
            errorText = 'um erro inesperado aconteceu, tente novamente'
          }
        } else {
          errorText = 'um erro inesperado aconteceu, tente novamente'
        }
        this.$swal.fire({
          type: 'error',
          title: 'Erro ao criar atendimento',
          text: errorText,
          showCancelButton: false,
          showConfirmButton: true
        })
      }
    },
    getPatients: _.debounce(function () {
      this.loading = true
      let collectionRef = db.collection('patients').where('company.identity', '==', this.company)
      if (this.saved.search !== '') {
        collectionRef = collectionRef
        .where('keywords', 'array-contains', this.saved.search.toUpperCase())
        .orderBy('name')
      } else {
        collectionRef = collectionRef
        .orderBy('timestamp', 'desc')
        .orderBy('name', 'asc')
      }
      return collectionRef.limit(this.saved.pagination.rowsPerPage).get().then(data => {
        this.saved.items = data.docs.map(item => firestoreUtil.docToObject(item))
        this.hideMoreBtn = Number.isInteger(this.saved.items.length / this.saved.pagination.rowsPerPage)
        this.loading = false
      }).catch(err => {
        this.loading = false
        console.error(err)
      })
    }, 500),
    gestationFormsBase () {
      let formsBase
      if (this.currentGestation && this.currentGestation.formsBase && this.currentGestation.formsBase['gestationalAge.info.date']) {
        formsBase = this.currentGestation.formsBase
        formsBase['gestationalAge.info.calculada'] = moment().diff(formsBase['gestationalAge.info.date'].toDate(), 'days')
      } else {
        formsBase = {}
        // formsBase['gestationalAge.info.calculo'] = 'desconhecido'
      }
      if (!this.currentGestation || !this.currentGestation.formsBase || !this.currentGestation.formsBase['gestationalAge.info.accessionNumber']) {
        formsBase['gestationalAge.info.accessionNumber'] = this.CompanyLastAn()
      }
      return formsBase
    },
    CompanyLastAn () {
      var an
      if (!this.companyUltraFetal.lastAn) {
        an = 1
        db.collection('companies').doc(this.companyUltraFetal.iuid).set({lastAn: core.firestore.FieldValue.increment(1)}, {merge: true})
      } else {
        an = (this.companyUltraFetal.lastAn + 1)
        db.collection('companies').doc(this.companyUltraFetal.iuid).update({lastAn: core.firestore.FieldValue.increment(1)})
        var str = '' + (an)
        var pad = '00000'
        an = pad.substring(0, pad.length - str.length) + str
      }
      return an
    }
  }
}
</script>

<style lang="stylus" scoped>
  .data-table >>> tr
    cursor pointer
</style>



// WEBPACK FOOTER //
// src/pages/Patients.vue